module.exports = {
	"articleTitle1": "Crafting community: The history of Ann Arbor Breweries ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Grizzly Peak",
	"articleLink1": "https://www.michigandaily.com/section/news/arts-ann-arbor-breweries",
	"articleLink2": "https://www.michigandaily.com/content/why-youre-paying-more-beer",
	"articleSnippet1": "Sep 14, 2015 ... Long began as executive chef at Grizzly Peak, where she met Ron Jeffries — \nhead brewer at the time — a University graduate and local ...",
	"articleSnippet2": "Jan 23, 2008 ... Clif Reeder: Though beer ingredients have increased in price, managers at \nGrizzly Peak Brewing Company, an Ann Arbor pub, have not ...",
	"foodRecommendations": [
		{
			"text": "They have gluten free buns for any Celiacs or dieters out there",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "25-to-40 percent",
	"address": "120 W Washington St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.280723,
		"lng": -83.74958
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/grizzlypeak.json
// module id = 886
// module chunks = 0